
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { listAllCate, deleteResourceCategory } from '@/api/resourceCategory';
import { Message } from 'element-ui';
import { wait } from '@/utils/wait';

export default extend(table, {
    namespaced: true,
    actions: {
        async listAllCate({ dispatch, state }, payload) {
            await wait(dispatch, 'ums.resource.category', async function() {
                await dispatch('getData', {
                    caller: listAllCate,
                    options: payload,
                    hasPage: false
                });
            })
        },
        async deleteResourceCategory({ dispatch }, payload) {
            await deleteResourceCategory(payload);
            Message({
				type: "success",
				message: "删除成功!"
            });
            dispatch('listAllCate');
        }
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/ums/resource/category-list.js